import React from 'react';
import PivotAnalysis from './components/PivotAnalysis';

const MarketingBudgetAnalysis = () => {
  return (
    <div className="min-h-screen">
      <PivotAnalysis />
    </div>
  );
};

export default MarketingBudgetAnalysis;
